import React, { useContext } from 'react';
import styles from './Dropdown.module.css';
import { DropdownContext } from './CustomDropdown';

export const CustomDropdownMenuList = ({ children, className = '', onClick, disabled = false, closed = true }) => {
  const { close } = useContext(DropdownContext);

  const handleClick = (e) => {
    if (disabled) return; // 🔒 Prevent action if disabled
    if (!closed) return;
    if (onClick) onClick(e);
    close();
  };

  return (
    <div
      className={`${styles.menuItem} ${disabled ? styles.disabled : ''} ${className}`}
      onClick={handleClick}
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}
    >
      {children}
    </div>
  );
};
